import { useMemo } from "react";

export function usePayerEngagementHistoryResources(
  payerPayeeEngagementId: string
) {
  return useMemo(
    () => [
      {
        resourceType: "PayerPayeeEngagement",
        resourceId: payerPayeeEngagementId
      }
    ],
    [payerPayeeEngagementId]
  );
}
